import { Page } from 'components/Page'
import { css, useTheme } from '@fable/theme'
import { getShareAuthor, getShareContent } from './helpers'
import { ShareObjectData, ShareObjectType } from '@fable/types'
import { useShareObject } from './useShareObject'
import { SharePageHeader } from './SharePageHeader'
import { SharePageActions } from './SharePageActions'
import { SharePageValueProps } from './SharePageValueProps'
import { SharePageQR } from './SharePageQR'
import { SharePageFooter } from './SharePageFooter'

interface Props {
  id: string
  data: ShareObjectData
  type: ShareObjectType
}

export const SharePageContent = ({ id, data, type }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const { onClickCta } = useShareObject()
  const author = getShareAuthor({ data, type })
  const { metadata, content } = getShareContent({
    id,
    type,
    data,
    onClickCta,
  })

  return (
    <Page
      head={metadata}
      className={css`
        background: ${colors.uiWhite};
        ${mediaQueries.mobileL} {
          background: ${colors.uiPearlUltraLight};
        }
      `}
    >
      <SharePageHeader id={id} type={type} />
      <div
        className={css`
          padding: 0 24px 24px;
          position: relative;
          overflow: hidden;
          ${mediaQueries.mobileL} {
            overflow: visible;
          }
        `}
      >
        <div
          className={css`
            margin: 0 auto;
            padding: 18px 0 80px;
            width: 100%;
            max-width: 392px;
            ${mediaQueries.mobileL} {
              margin-bottom: -140px;
              padding: 33px 0 80px;
            }
          `}
        >
          {content}
          <SharePageActions
            id={id}
            type={type}
            name={author?.display_name || ''}
          />
          <hr
            className={css`
              margin: 40px 0;
              border: none;
              height: 1px;
              background-color: ${colors.uiSilverGrey};
            `}
          />
          <SharePageValueProps />
        </div>
        <SharePageQR />
      </div>
      <SharePageFooter id={id} type={type} />
    </Page>
  )
}
